import styles from "./AdminSettings.module.css";
import backgroundImage from "../../../assets/images/background.jpg";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getOrganisation, updateCustomField } from "./AdminSettingsApi";
import { useEffect } from "react";
import { setCustomFields } from "./AdminSettingsSlice";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const AdminSettings = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const customFields = useAppSelector(
    (state) => state.admin.settings.customFields
  );
  const minimumSchedulingNoticeCustomField = customFields.find(
    ({ customKey }) => "Booking Minimum Scheduling Notice" === customKey.name
  );
  const dateRangeCustomField = customFields.find(
    ({ customKey }) => "Booking Date Range" === customKey.name
  );
  const bgStyle = {
    background: `lightgray url(${backgroundImage}) 50% / cover no-repeat`,
    display: "flex",
    FlexDirection: "column",
    minHeight: "100vh",
    alignItems: "stretch",
  };

  const handleBookingOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    history.push("/home");
  };

  const handleSaveOnClick = async (
    event: React.MouseEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    if (minimumSchedulingNoticeCustomField) {
      const minimumNotice = document.getElementById(
        "booking-min-notice"
      ) as HTMLInputElement;
      dispatch(
        updateCustomField(
          {
            uuid: minimumSchedulingNoticeCustomField.uuid,
            value: minimumNotice.value,
          },
          true
        )
      );
    }

    if (dateRangeCustomField) {
      const dateRange = document.getElementById(
        "date-range"
      ) as HTMLInputElement;
      dispatch(
        updateCustomField(
          {
            uuid: dateRangeCustomField.uuid,
            value: dateRange.value,
          },
          true
        )
      );
    }

    toast.success("Successfully updated settings");
  };

  useEffect(() => {
    dispatch(getOrganisation());
  }, []);

  return (
    <div className={styles.Page} style={bgStyle}>
      <div className={styles.PageContainer}>
        <div className={styles.Container}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p style={{ fontWeight: 700, fontSize: 18 }}>
              Calendar Availability
            </p>
          </div>

          <form onSubmit={handleSaveOnClick}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                marginTop: 10,
              }}
            >
              {minimumSchedulingNoticeCustomField && dateRangeCustomField && (
                <>
                  <label>Minimum Scheduling Notice</label>
                  <div style={{ width: "100%" }}>
                    <input
                      value={minimumSchedulingNoticeCustomField.value}
                      onChange={(event) => {
                        dispatch(
                          setCustomFields([
                            {
                              ...minimumSchedulingNoticeCustomField,
                              value: event.target.value,
                            },

                            dateRangeCustomField,
                          ])
                        );
                      }}
                      type="number"
                      id="booking-min-notice"
                      name="booking-min-notice"
                      min="0"
                      required
                      style={{
                        width: `calc(50% - 14px)`,
                        height: "32px",
                        padding: "0 8px 0 12px",
                        border: "1px solid black",
                        borderRadius: "4px",
                        marginRight: 4,
                        marginTop: 2,
                        marginBottom: 2,
                      }}
                    ></input>
                    <select
                      id="booking-min-notice-unit"
                      name="booking-min-notice-unit"
                      required
                      style={{
                        width: `calc(50% - 14px)`,
                        height: "32px",
                        padding: "0 8px 0 12px",
                        border: "1px solid black",
                        borderRadius: "4px",
                        marginTop: 2,
                        marginBottom: 2,
                      }}
                    >
                      <option value="days" selected>
                        Days
                      </option>
                    </select>
                  </div>
                </>
              )}
              <br />

              {dateRangeCustomField && minimumSchedulingNoticeCustomField && (
                <>
                  <label>Date Range</label>
                  <div style={{ width: "100%" }}>
                    <input
                      onChange={(event) => {
                        dispatch(
                          setCustomFields([
                            {
                              ...dateRangeCustomField,
                              value: event.target.value,
                            },

                            minimumSchedulingNoticeCustomField,
                          ])
                        );
                      }}
                      value={dateRangeCustomField.value}
                      type="number"
                      id="date-range"
                      name="date-range"
                      min="0"
                      required
                      style={{
                        width: `calc(50% - 14px)`,
                        height: "32px",
                        padding: "0 8px 0 12px",
                        border: "1px solid black",
                        borderRadius: "4px",
                        marginRight: 4,
                        marginTop: 2,
                        marginBottom: 2,
                      }}
                    ></input>
                    <select
                      id="date-range"
                      name="date-range"
                      style={{
                        width: `calc(50% - 14px)`,
                        height: "32px",
                        padding: "0 8px 0 12px",
                        border: "1px solid black",
                        borderRadius: "4px",
                        marginTop: 2,
                        marginBottom: 2,
                      }}
                      required
                    >
                      <option value="days" selected>
                        Days
                      </option>
                    </select>
                  </div>
                </>
              )}
              <button type="submit" className={styles.Button}>
                Save
              </button>
              <button
                className={styles.BookButton}
                onClick={handleBookingOnClick}
              >
                Preview booking page
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
